export class BannerMessage {
    constructor(
        public messageComponent: any,
        public closeButtonText?: string,
        public actionButtonText?: string,
        public bannerAction?: () => void,
        public icon?: string,
        public backgroundColor?: string,
        public color?: string,
        public priority = 0,
        public data?: any,
        public oncePerSession = false,
        public oncePerBrowser = false,
        public showOnLoginScreen = false
    ) {
    }
}
